import React from 'react';

/**
 * Photography with intrinsic dimensions so nothing shifts while it loads.
 * Everything below the fold is lazy; the hero passes `priority`.
 */
export const SmartImage = ({ image, className = '', sizes, priority = false, ...rest }) => (
  <img
    src={image.src}
    alt={image.alt}
    width={image.width}
    height={image.height}
    sizes={sizes}
    loading={priority ? 'eager' : 'lazy'}
    decoding={priority ? 'sync' : 'async'}
    fetchPriority={priority ? 'high' : undefined}
    className={className}
    {...rest}
  />
);

export default SmartImage;
